import { Button, Popover } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { ReactComponent as HelpIcon } from "../../../assets/images/Help.svg";
import PopoverTitle from "../../common/PopoverTitle";
import clsx from "clsx";
import "./CreateVence.scss";

function CreateVence(props) {
  const {
    onBackButtonClick,
    setCurrentStep,
    currentStepDetails,
    venceStep3Popover,
    venceStep11Popover,
    // setHerdMarkerDetails,
  } = props;

  const contentOfInclusion = (
    <div>
      <p>
        You can create three types of vences, depending on whether you want to:
      </p>
      <ul
        className="tutorial-guide-list-item"
        style={{ paddingInlineStart: "25px" }}
      >
        <li>
          <strong>exclude</strong> cattle from an area (like a riparian zone).
        </li>
        <li>
          <strong>include</strong> cattle inside an area (like a section of
          pasture).
        </li>
        <li>
          <strong>move</strong> cattle steadily across an area (creep grazing).
        </li>
      </ul>
      <p>
        For now, let’s select <strong>INCLUSION</strong> since we want to keep
        the cattle in the top section of the pasture.
      </p>
    </div>
  );

  const contentOfExclusion = (
    <div>
      <p>
        Select <strong>EXCLUSION</strong> this time.
      </p>
    </div>
  );

  return (
    <div>
      <Button
        block
        className="back-button"
        onClick={() => onBackButtonClick()}
        icon={<ArrowLeftOutlined />}
      >
        BACK
      </Button>
      <div className="create-vence">
        <div className="header">
          <label className="title">Create Vence</label>
          <Button
            type="text"
            style={{ marginLeft: "auto" }}
            icon={<HelpIcon className="help-icon" />}
          />
        </div>
        <div className="create-vence-body">
          <Popover
            title={PopoverTitle}
            content={contentOfInclusion}
            placement="leftTop"
            trigger="hover"
            visible={venceStep3Popover}
          >
            <Button
              block
              onClick={() => {
                setCurrentStep((step) => step + 1);
              }}
              id="inclusion-vence-button"
              className={clsx("sub-item", {
                "overlay-element-active":
                  currentStepDetails.overlayElementsId?.includes(
                    "inclusion-vence-button"
                  ),
              })}
            >
              Inclusion
            </Button>
          </Popover>
          <Popover
            title={PopoverTitle}
            content={contentOfExclusion}
            placement="leftTop"
            trigger="hover"
            visible={venceStep11Popover}
          >
            <Button
              block
              onClick={() => {
                setCurrentStep((step) => step + 1);
              }}
              id="exclusion-vence-button"
              className={clsx("sub-item", {
                "overlay-element-active":
                  currentStepDetails.overlayElementsId?.includes(
                    "exclusion-vence-button"
                  ),
              })}
            >
              Exclusion
            </Button>
          </Popover>
          <Button block className="sub-item">
            Movement
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CreateVence;
